import React from 'react';
import { useIntl } from 'react-intl';
import Outlet from 'services/router/outlet';
import Page from 'pages/layout/page';
import AppHeaderControls from 'pages/shared/app-header-controls';
import application from 'services/application';
import authentication from 'services/authentication';

import messages from './online-support.i18n';
import { testId } from './online-support.settings';
import styles from './online-support.module.scss';

const OnlineSupport: React.FunctionComponent<unknown> = () => {
  const { formatMessage } = useIntl();
  const currentProduct = application.current;

  return (
    <Page
      testId={testId.page}
      title={
        authentication.isAuthenticated() && formatMessage(messages.pages.help.onlineSupport.seo[currentProduct].title)
      }
      seo={{
        title: formatMessage(messages.pages.help.onlineSupport.seo[currentProduct].title),
        description: formatMessage(messages.pages.help.onlineSupport.seo[currentProduct].title),
      }}
      className={styles.page}
    >
      {!authentication.isAuthenticated() && <AppHeaderControls login signup />}
      <Page.Row>
        <Outlet />
      </Page.Row>
    </Page>
  );
};

export default OnlineSupport;
